
export const shiftsList = [
    {key: 'M', value: 'Matutino'},
    {key: 'V', value: 'Vespertino'},
    {key: 'N', value: 'Nocturno'}
]